import { useCallback, useState } from 'react'
import List, { Item } from '@talkdesk/cobalt-react-list'
import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'
import Avatar from '@talkdesk/cobalt-react-avatar'
import { Text } from '@talkdesk/cobalt-react-typography'
import Link from '@talkdesk/cobalt-react-link'
import Popup from '@talkdesk/cobalt-react-popup'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import Divider from '@talkdesk/cobalt-react-divider'
import PortalProvider, { Portal } from '@talkdesk/cobalt-react-portal-provider'
import usePosition from '@talkdesk/cobalt-react-position-hook'
import useOutsideClick from '@talkdesk/cobalt-react-outside-click-hook'
import { LOGOUT, PROCEED_TO_TALKDESK } from '../../constants/ui.labels'
import { LOGOUT_PAGE, ROOT } from '../../constants/links'
import { navigateTo } from '../../utils/redirect/navigator'

const renderAvatar = (name) => {
  const initials = name
    .trim()
    .split(/\s+/)
    .map((str) => str[0])
  const first = initials.shift() || ''
  const last = initials.pop() || ''

  return <Avatar size='small' color='purple'>{`${first}${last}`}</Avatar>
}

const renderMenu = (displayLogoutMenuOnly) => (
  <List>
    {!displayLogoutMenuOnly && <ProceedToTalkdeskItem />}
    <LogoutItem />
  </List>
)

const ProceedToTalkdeskItem = () => (
  <Item>
    <Box paddingLeft='4' paddingTop='6' paddingBottom='3'>
      <Link onClick={() => navigateTo(ROOT)}>{PROCEED_TO_TALKDESK}</Link>
    </Box>
  </Item>
)

const LogoutItem = () => (
  <Item>
    <Box paddingLeft='4' paddingY='6'>
      <Link onClick={() => navigateTo(LOGOUT_PAGE)}>{LOGOUT}</Link>
    </Box>
  </Item>
)

const NavbarMenu = ({ name, email, displayLogoutMenuOnly = false }) => {
  const avatar = renderAvatar(name)
  const menu = renderMenu(displayLogoutMenuOnly)
  const theme = useTheme()
  const [visible, setVisible] = useState(false)
  const [anchorNode, setAnchorNode] = useState(null)
  const anchorRef = useCallback((refNode) => setAnchorNode(refNode), [])
  const { position, elementRef } = usePosition(anchorNode, {
    origin: 'SE',
    direction: 'SW',
    autoGap: 3,
  })
  const handleClick = () => {
    visible ? setVisible(false) : setVisible(true)
  }
  const handleOutsideClick = useOutsideClick({
    handler: () => {
      setVisible(false)
    },
    refs: [anchorNode],
  })

  return (
    <PortalProvider>
      <Link ref={anchorRef} onClick={handleClick}>
        {avatar}
      </Link>
      <Portal>
        <Popup
          forwardedRef={elementRef}
          visible={visible && !!position}
          style={{ ...position }}
          {...handleOutsideClick}
        >
          <Flex alignY='center' gap='3' padding='3'>
            <Flex gap='2'>
              <Box paddingLeft='1' paddingRight='1'>
                {avatar}
              </Box>
              <Flex direction='column'>
                <Text weight='medium'>{name}</Text>
                <Text inline size='small' color={theme.gray600}>
                  {email}
                </Text>
              </Flex>
            </Flex>
          </Flex>
          <Divider />
          <Flex direction='column'>{menu}</Flex>
        </Popup>
      </Portal>
    </PortalProvider>
  )
}

export default NavbarMenu
